export class ListSqlQueryExecutionsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListSqlQueryExecutionsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortSqlQueryExecutionBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSqlQueryExecutionsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
